import Box from "@mui/material/Box";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Flx from "../../../../components/layout/Flx";
// import LoanChecklistRenderer from "../../components/LoanChecklistRenderer";
import {
  AddRounded,
  ChecklistOutlined,
  HistoryOutlined,
  PushPinOutlined,
  PushPinTwoTone,
} from "@mui/icons-material";
import { Button, Card, Container, IconButton, Tooltip } from "@mui/material";
import Htag from "../../../../components/typography/Htag";
import Txt from "../../../../components/typography/Txt";

import { grey } from "@mui/material/colors";
import { isEmpty } from "lodash";
import ChecklistCommentsButton from "../../../../components/common/Loan/LoanChecklist/buttons/ChecklistCommentsButton";
import LoanChecklist from "../../../../components/common/Loan/LoanChecklist/LoanChecklist";
import CollateralSearchAction from "../../components/CollateralSearchAction";
import {
  sidebarChecklistHideTemplates,
  sidebarChecklistShowComments,
  sidebarChecklistShowHistory,
  sidebarChecklistTogglePinned,
  sidebarChecklistToggleShowTemplates,
} from "../../../../redux/reducers/sidebarReducer";

const LoanDrilldownChecklistTab = ({ value, tab, includedInSidebar }) => {
  const checklist = useSelector((state) => state.sidebar?.checklist);
  // const checklistData = useSelector((state) => state.sidebar?.checklist?.data);
  const checklistPinned = checklist?.pinned;
  const checklistData = checklist?.data;
  const showComments = checklist?.showComments;
  const taskListUpdateHistory = checklistData?.taskListUpdateHistory || [];
  const dispatch = useDispatch();
  const onUnpin = useCallback((props) => {
    dispatch(sidebarChecklistTogglePinned());
  }, []);

  const checklistContent = (
    <Container maxWidth="xl">
      <Card sx={{ p: 2 }}>
        {checklistPinned ? (
          <Flx column gap={2} center sx={{ p: 4, background: grey[300] }}>
            <PushPinTwoTone />
            <Txt secondary>
              This checklist is pinned. To unpin, click the button below.
            </Txt>
            <Button onClick={onUnpin}>Unpin Checklist</Button>
          </Flx>
        ) : (
          <>
            <Flx fw jb ac sx={{ mb: 1 }}>
              <Flx ac g={1}>
                <ChecklistOutlined />
                <Htag h3 sx={{ fontWeight: 800 }}>
                  {checklistData?.checklistName
                    ? `${checklistData?.checklistName} Checklist`
                    : "Loan Checklist"}
                </Htag>
              </Flx>
              <Flx ac gap={0}>
                {isEmpty(checklistData?.comments) ? null : (
                  <ChecklistCommentsButton
                    comments={checklistData?.comments}
                    active={showComments}
                    onClick={() => {
                      dispatch(sidebarChecklistShowComments());
                    }}
                  />
                )}
                {isEmpty(taskListUpdateHistory) ? null : (
                  <Tooltip title="Show Update History">
                    <IconButton
                      onClick={() => {
                        dispatch(sidebarChecklistShowHistory());
                        dispatch(sidebarChecklistHideTemplates());
                      }}
                    >
                      <HistoryOutlined className="thin" />
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title="Create New Checklist">
                  <IconButton
                    onClick={() =>
                      dispatch(sidebarChecklistToggleShowTemplates())
                    }
                  >
                    <AddRounded className="thin" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Pin Checklist">
                  <IconButton
                    onClick={() => dispatch(sidebarChecklistTogglePinned())}
                  >
                    <PushPinOutlined className="thin" />
                  </IconButton>
                </Tooltip>
              </Flx>
            </Flx>
            <LoanChecklist inline />
          </>
        )}
      </Card>
    </Container>
  );

  if (includedInSidebar) {
    return (
      <Box sx={{ px: 3 }}>
        <LoanChecklist inline />
      </Box>
    );
    // return checklistContent;
  }
  return (
    <>
      {/* <LoanFilesContent />
      <Divider sx={{ m: 4, borderStyle: "dashed" }} /> */}

      {/* Post-closing action: confirm the closing package reached Sourcepoint
          for indexing (and later, that recorded mailbacks came back imaged). */}
      <Container maxWidth="xl" sx={{ pt: 2 }}>
        <CollateralSearchAction />
      </Container>
      <Box sx={{ py: 2 }}>{checklistContent}</Box>
    </>
  );
};

export default LoanDrilldownChecklistTab;
